import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import {
    AuthenticationService,
    EspaceClientService,
    User,
} from '@kv-common-components/kx-services';
import { NGXLogger } from 'ngx-logger';
import { RouteEnum } from '@shared/services/route-enum';
import { PersonneHelperService } from '@shared/services/personne-helper.service';

@Component({
    selector: 'app-otp-connexion',
    templateUrl: 'otp-connexion.component.html',
    styleUrls: ['otp-connexion.component.scss'],
})
export class OtpConnexionComponent implements OnInit {
    static readonly keyMsgErrorOtpCalculate = 'otp.connexion.calculate.error';
    static readonly keyMsgErrorOtpValidate = 'otp.connexion.validate.error';
    static readonly keyMsgErrorBadOtp = 'otp.connexion.bad.error';

    currentUser: User = null;

    otpControl = new FormControl();
    otpForm: FormGroup;
    isLoading = false;
    isOtpCalculate = false;
    isError = false;
    keyMsgError = null;
    phone = null;

    constructor(
        private logger: NGXLogger,
        private authenticationService: AuthenticationService,
        private espaceClientService: EspaceClientService,
        private personneHelper: PersonneHelperService,
        private router: Router
    ) {}

    ngOnInit(): void {
        this.currentUser = this.authenticationService.currentUserValue;
        this.initPhone();
        this.initForm();
        this.calculateOtp();
    }

    initForm() {
        this.otpForm = new FormGroup({});
        this.otpControl.setValidators([
            Validators.required,
            Validators.pattern('[0-9]{6}'),
        ]);
        this.otpForm.addControl('otp', this.otpControl);
    }

    initPhone() {
        this.phone = localStorage.getItem('currentPhone');
        this.phone = this.phone.substring(
            this.phone.length - 4,
            this.phone.length
        );
        this.phone =
            this.phone.substring(0, 2) + ' ' + this.phone.substring(2, 4);
    }

    calculateOtp(): void {
        this.isLoading = true;
        this.isOtpCalculate = false;
        this.isError = false;
        this.otpForm.get('otp').setValue(null);
        this.authenticationService.updateCurrentUser(this.currentUser);
        this.authenticationService
            .postCalculerOtpDoubleAuthentication(this.currentUser.idPersonne)
            .subscribe(
                (result) => {
                    this.checkOtpDoubleAuthenticationCalculationResponse(
                        result
                    );
                },
                () => {
                    this.initDisplayError(
                        OtpConnexionComponent.keyMsgErrorOtpCalculate
                    );
                }
            );
    }

    checkOtpDoubleAuthenticationCalculationResponse(resultCalcule: any): void {
        this.isLoading = false;
        this.authenticationService.updateCurrentUser(null);
        this.isOtpCalculate = Boolean(resultCalcule.idWeb);
        if (!this.isOtpCalculate) {
            this.initDisplayError(
                OtpConnexionComponent.keyMsgErrorOtpCalculate
            );
        }
    }

    validateOtp(): void {
        if (!this.isLoading) {
            this.isLoading = true;
            this.isError = false;
            this.authenticationService.updateCurrentUser(this.currentUser);
            this.authenticationService
                .postValiderOtpDoubleAuthentication(
                    this.currentUser.idPersonne,
                    this.otpForm.value.otp
                )
                .subscribe(
                    (result) => {
                        this.checkOtpDoubleAuthenticationValidationResponse(
                            result
                        );
                    },
                    () => {
                        this.initDisplayError(
                            OtpConnexionComponent.keyMsgErrorOtpValidate
                        );
                    }
                );
        }
    }

    checkOtpDoubleAuthenticationValidationResponse(
        resultValidation: any
    ): void {
        if (resultValidation.codeValide) {
            this.logger.info(
                `idPersonne: ${this.currentUser.idPersonne} otp succesfully validate`
            );
            this.currentUser.accessToken = resultValidation.accessToken;
            this.currentUser.expirationDate = resultValidation.expirationDate;
            this.authenticationService.updateCurrentUser(this.currentUser);
            this.espaceClientService
                .refreshEspaceClient(this.currentUser.idPersonne)
                .subscribe((data) => {
                    this.personneHelper.initCurrentUser(data, this.currentUser);
                    this.isLoading = false;
                    this.router.navigateByUrl(RouteEnum.dashboard);
                });
        } else {
            this.initDisplayError(OtpConnexionComponent.keyMsgErrorBadOtp);
        }
    }

    initDisplayError(keyMessageError: string): void {
        this.isLoading = false;
        this.isError = true;
        this.keyMsgError = keyMessageError;
    }
}
